import { useauthMeQuery } from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';
import { useUserGuideStore } from '@shared/store/user-guide.store';
import { RiCloseLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { userGuideTourSteps } from './user-guide-tour.constants';
import { userGuideModules } from './user-guide.constants';
import { isUserGuideKeyAvailable } from './utils/user-guide-availability';

export function UserGuidePopupView() {
  const { setOpenUserGuide, startTour } = useUserGuideStore();
  const { t } = useTranslation();
  const { data } = useauthMeQuery(cacheOnly);
  const tourGuideEnabled = Boolean(data?.authMe?.data?.user?.tourGuideEnabled);
  const modules = userGuideModules(t, tourGuideEnabled).filter((module) => isUserGuideKeyAvailable(module.key));
  const tourSteps = userGuideTourSteps(t, tourGuideEnabled).filter((step) => isUserGuideKeyAvailable(step.key));

  return (
    <>
      <div className="fixed inset-0 z-90 bg-black/40" onClick={() => setOpenUserGuide(false)} />
      <div className="fixed bottom-20 left-4 z-100 w-75 max-h-[70vh] flex flex-col rounded-xl bg-surface shadow-lg border border-gray-700">
        <div className="flex items-start justify-between gap-2 p-4 border-b border-gray-700">
          <div>
            <p className="text-[15px] font-semibold text-text-900 leading-tight mb-0.5">{t('user_guide')}</p>
            <p className="text-xs text-text-600 leading-tight">{t('user_guide_subtitle')}</p>
          </div>
          <RiCloseLine
            className="cursor-pointer text-text-600 shrink-0"
            size={18}
            onClick={() => setOpenUserGuide(false)}
          />
        </div>
        <div className="overflow-y-auto p-2 space-y-0.5">
          {modules.map((module) => {
            const tourStepIndex = tourSteps.findIndex((step) => step.key === module.key);
            return (
              <div
                key={module.key}
                className="rounded-md px-3 py-2 cursor-pointer hover:bg-gray-200"
                onClick={() => tourStepIndex !== -1 && startTour(tourStepIndex)}
              >
                <p className="text-sm font-medium text-text-900 leading-tight mb-0.5">{module.title}</p>
                <p className="text-xs text-text-600 leading-tight">{module.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
